/**
 * Revisão PP6-valr (8a): início PADRÃO de uma proposta de política da simulação = AMANHÃ (America/Sao_Paulo, o fuso
 * da simulação e do agregado). Uma proposta com início "hoje" que não fosse aprovada no mesmo dia viraria retroativa
 * na virada (409 `VIGENCIA_EXPIRADA_NA_APROVACAO`) e teria de ser proposta de novo. A pessoa ainda pode escolher hoje.
 */
export const FUSO_POLITICAS = 'America/Sao_Paulo'

/** `AAAA-MM-DD` de hoje + `dias` no fuso das políticas (`agora` injetável para teste). */
export const dataIsoNoFuso = (dias: number, agora: Date = new Date()): string => {
  const hojeSp = new Intl.DateTimeFormat('en-CA', {
    timeZone: FUSO_POLITICAS,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(agora)
  const [a, m, d] = hojeSp.split('-').map(Number)
  const alvo = new Date(Date.UTC(a, m - 1, d + dias))
  return alvo.toISOString().slice(0, 10)
}

/** Início padrão das propostas: amanhã no fuso das políticas. */
export const inicioPadraoProposta = (agora: Date = new Date()): string => dataIsoNoFuso(1, agora)
